import {
    queryFxgDetail,
    queryFxgCategoryProperties,
    editFxgDetail,
    editFxgDetail2,
    fxgBatchUpdateCategory,
    fxgBrandList,
    fxgBrandListV2,
    fxgRefreshBrand,
    getBrandListV2PlatForm,
    batchBrandFill,
    submitBrandTask,
    querySubmitBrandResult,
    fxgSizeTemplateList,
    fxgGxSizeTemplateList,
    applyToOtherShop,
    fxgAddOrUpdateSizeTemplate,
    fxgSizeSort,
    fxgGenerateItemSizeInfo,
    fxgRecommendCatStatus,
    queryFxgDetailSupplier,
    getScmCodeFxg,
    saveBatchTempConf,
    queryBatchDetail,
    batchPublishItem,
  } from '@/api/prod/center'

import { _filterInvalidImg } from './kuaishou.js'

// 获取抖音平台数据
export function getFxgDetail(data) {
    return queryFxgDetail(data).then(res => {
      if (res.result === 1) {
        return fxgDataMap(res.data)
      }
      return null;
    })
  }
// 获取抖音平台数据(供销商小店版)
export function getFxgDetailSupplier(data) {
    return queryFxgDetailSupplier(data).then(res => {
      if (res.result === 1) {
        return fxgDataMap(res.data)
      }
      return null;
    })
  }
  // 获取抖音AI类目白名单
  
  export function getScmCodeFxgPlat(data) {
    return getScmCodeFxg(data).then(res => {
      if (res.result === 1) {
        return res.data
      }
      return false;
    })
  }
  // 抖音数据映射
  export function fxgDataMap(data, isRequest) {
    let skuList = _.cloneDeep(data.skuList || []);
    if (skuList && skuList.length > 0) {
      skuList = skuList.map(item => {
        return isRequest ? {
          ...item,
          skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
        } : {
          ...item,
          skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
        }
      })
    }
    return isRequest ? {
      ...data,
      mobile: (data.mobile || '').trim(),
      skuList: skuList,
      categoryIds: data.categoryIds.join(','),
      categoryLeafId: data.categoryIds[data.categoryIds.length-1] || '',
      qualityKey1: data.qualityKey1.join(','),
      qualityKey2: data.qualityKey2.join(','), // 委托进口协议
      qualityKey3: data.qualityKey3.join(','), //质检报告
      qualityKey4: data.qualityKey4.join(','), // 人物肖像授权资源 
      qualityKey5: data.qualityKey5.join(','), // 老字号认证证书
      qualityKey6: data.qualityKey6.join(','), // 赠品资源
      pic: _filterInvalidImg(data.pic).join('|'),
      mainImages34: _filterInvalidImg(data.mainImages34).join('|'),
      guideImg: _filterInvalidImg(data.guideImg).join('|'),
      videoInfo: JSON.stringify(data.videoInfo ? data.videoInfo : []),
      description: _filterInvalidImg(data.description).join('|'),
      specifications: JSON.stringify(data.specifications ? data.specifications : []),
      sizeTemplateConf: JSON.stringify(data.sizeTemplateConf ? data.sizeTemplateConf : []),
      shippingOriginInfo: JSON.stringify(data.shippingOriginInfo || {}),
      weight: data.weight || '0.00',
      shopBrandConf: JSON.stringify(data.shopBrandConf ? data.shopBrandConf : []),
      // timeSpecList:  data.timeSpecList?.filter(item => Number(item) !== 0) || [],
      deliveryDelayDay: data.presellType === 2 ? 
        (Array.isArray(data.deliveryDelayDay) && data.deliveryDelayDay.length > 0 ? 
            data.deliveryDelayDay.join(',') : 
            0
        ) : data.deliveryDelayDay
    } : {
      ...data,
      skuList: skuList,
      categoryIds: (data.categoryIds || '').split(',').filter(id => !!id),
      presellType: data.presellType === null ? 0 : data.presellType,
      // deliveryDelayDay: data.deliveryDelayDay === null ? 2 : data.deliveryDelayDay,
      deliveryDelayDay: data.presellType === 2 ? 
      (data.deliveryDelayDay === 0 ? [] : [data.deliveryDelayDay]) : 
      (data.deliveryDelayDay === null ? 2 : data.deliveryDelayDay),
      payType: data.payType === null ? 1 : data.payType,
      qualityKey1: (data.qualityKey1 || '').split(','),
      qualityKey2: (data.qualityKey2 || '').split(','), // 委托进口协议
      qualityKey3: (data.qualityKey3 || '').split(','), //质检报告
      qualityKey4: (data.qualityKey4 || '').split(','), // 人物肖像授权资源 
      qualityKey5: (data.qualityKey5 || '').split(','), // 老字号认证证书
      qualityKey6: (data.qualityKey6 || '').split(','), // 赠品资源
      pic: (data.pic || '').split('|'),
      mainImages34: data.mainImages34 ? data.mainImages34.split('|') : [],
      guideImg: data.guideImg ? data.guideImg.split('|') : [],
      videoInfo: data.videoInfo ? JSON.parse(data.videoInfo) : [],
      description: (data.description || '').split('|'),
      specifications: data.specifications ? JSON.parse(data.specifications) : [],
      limitPerBuyer: data.limitPerBuyer || '', // 单用户累计限购（件） 这种限购数据需要把0转为空串
      maximumPerOrder: data.maximumPerOrder || '', // 单用户每次限购（件）
      minimumPerOrder: data.minimumPerOrder || '', // 单用户每次至少购买（件）
      templateConfig: data.templateConfig ? JSON.parse(data.templateConfig) : [],
      shippingOriginInfo: JSON.parse(data.shippingOriginInfo || '{}'),
      sizeTemplateConf: data.sizeTemplateConf ? JSON.parse(data.sizeTemplateConf) : [],
      sizeTemplateList: data.sizeTemplateList || [],
      shopBrandConf: data.shopBrandConf ? JSON.parse(data.shopBrandConf) : [],
    }
  }
  
  // 抖音平台类目属性查询
  export function getFxgCategoryProperties(data) {
    return queryFxgCategoryProperties(data).then(res => {
      if (res.result === 1) {
        return res.data;
      }
      return null;
    })
  }
  export function editFxgInfo(data) {
    return editFxgDetail(fxgDataMap(data, true)).then(res => {
      if (res.result === 1) {
        return true;
      }
      return false;
    })
  }
  export function editFxgInfo2(data,expandParams) {
    let params = {
      itemInfo:{...fxgDataMap(data, true)},
      ...expandParams
    }
    return editFxgDetail2(params).then(res => {
      if (res.result === 1) {
        return true;
      }
      return false;
    })
  }


  // 批量修改类目
export function batchFxgCategory(data) {
    return fxgBatchUpdateCategory(data).then(res => {
      if (res.result === 1) {
        return true
      } else {
        return false
      }
    })
  }
  

function _formatBrandItem({name, vid}) {
  return {
    id: vid,
    name
  }
}
// 获取当前类目是否需要授权品牌
export function isAuthRequired(data) {
  return fxgBrandList({
    ...data
  }).then(res => {
    if (res.result === 1) {
      const {records, total} = res.data
      if (!total) return false
      return !!records[0].authRequired
    } else {
      return false
    }
  })
}

// 获取品牌列表
export function getBrandList(data) {
  return fxgBrandList(data).then(res => {
    return res.data || [];
  })
}

export function getBrandListV2(data) {
  return fxgBrandListV2(data).then(res => {
    return res.data || [];
  })
}

export function refreshBrand(data) {
  return fxgRefreshBrand(data).then(res => {
    return res.result === 1
  })
}

// 获取品牌列表通过各个平台
export function getBrandListPlatForm(data) {
  return getBrandListV2PlatForm(data).then(res => {
    return res.data || [];
  })
}
// 批量填充品牌信息
export function getShopsBrandFill(data) {
  return batchBrandFill(data).then(res => {
    return res.data || [];
  })
}
// 一键应用到其他店铺
export function ApplyToOtherShop(data) {
  return applyToOtherShop(data).then(res => {
    return res.data || [];
  })
}

// 同步店铺品牌
export const syncShopBrand = (data) => {
  return submitBrandTask(data).then(res => {
      return res.result === 1
  })
}

// 查看店铺品牌同步进度
export const getSyncShopBrandStatus = (data) => {
  return querySubmitBrandResult(data).then(res => {
      if (res.result === 1) {
          return res.data
      } else {
          return false
      }
  })
}

// 查询尺码模板列表
export const queryFxgSizeTemplateList = (data, opts) => {
  if(opts.source === 'fxg_gx') {
    return fxgGxSizeTemplateList(data).then(res => {
      if(res.result === 1) {
        return res.data
      }
      return false
    })
  } else {
    return fxgSizeTemplateList(data).then(res => {
      if(res.result === 1) {
        return res.data
      }
      return false
    })
  }
}

// 更新或保存尺码模板
export const addOrUpdateSizeTemplate = (data) => {
  return fxgAddOrUpdateSizeTemplate(data).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

// 尺码大小排序
export const generateFxgSizeInfo = (data, platform) => {
  return fxgGenerateItemSizeInfo(data, platform).then(res => {
    if(res.result === 1) {
      return res.data || {}
    }
    return {}
  })
}
// 尺码大小排序
export const queryFxgSizeSort = (data) => {
  return fxgSizeSort(data).then(res => {
    if(res.result === 1) {
      return res.data || []
    }
    return []
  })
}

// 校验商品是否符合抖音的类目预测
export const fxgCatStatus = (data) => {
  return fxgRecommendCatStatus(data).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
// 针对批量铺货设置保存
export const saveBatchTempConfFxg = (data) => {
  return saveBatchTempConf({data,platform:'fxg'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}

// 获取批量铺货商品详情信息
export const queryBatchDetailFxg = (data) => {
  return queryBatchDetail({data,platform:'fxg'}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

// 批量铺货
export const batchPublishItemFxg = (data) => {
  return batchPublishItem({data,platform:'fxg'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}